/* ==========================================================================
   Miss Blooms — Christmas in July festive layer (shared behaviour)
   - fills .mb-snow[data-flakes] with drifting flakes
   - reveals .mb-reveal on scroll (adds .mb-in)
   - re-inits on Shopify Theme Editor section load (drag-drop friendly)
   Respects prefers-reduced-motion. Idempotent.
   ========================================================================== */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function makeSnow(el) {
    if (REDUCE || el.dataset.mbSnowDone === '1') return;
    el.dataset.mbSnowDone = '1';
    var n = parseInt(el.getAttribute('data-flakes') || '20', 10);
    var glyphs = ['❄', '✦', '❅']; // ❄ ✦ ❅
    for (var i = 0; i < n; i++) {
      var s = document.createElement('i');
      s.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
      s.style.left = (Math.random() * 100) + '%';
      s.style.fontSize = (Math.random() * 22 + 16) + 'px';
      s.style.animationDuration = (Math.random() * 9 + 8) + 's';
      s.style.animationDelay = (-Math.random() * 14) + 's';
      s.style.opacity = (Math.random() * 0.45 + 0.45).toFixed(2);
      el.appendChild(s);
    }
  }

  var revealIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mb-in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.12 })
    : null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mb-reveal:not(.mb-in)');
    els.forEach(function (el) {
      if (revealIO) revealIO.observe(el); else el.classList.add('mb-in');
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.mb-snow').forEach(makeSnow);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Shopify Theme Editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
